import React, { useState, useEffect } from "react";
import { Button, Row, Col, Rate, Input, Upload } from "antd";
import {
  SearchOutlined,
  ArrowLeftOutlined,
  PlusOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import MediaQuery from "react-responsive";
import { useLocation } from "react-router-dom";
import history from "../../../routes/history";
import ImgCrop from "antd-img-crop";
import { fetchToken } from "../../../API/API";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import {
  getCompanyProfileDetails,
  resetCompanyProfileDetails,
  updateCompanyProfileDetails,
} from "../../../redux/actions";
import { getImage } from "../../../utilities/storageOperations/downloadURL";
import editicon from "../../../assets/img/editicon.png";
import GroupCamera from "../../../assets/icons/GroupCamera.png";
import TopAlert from "../../../components/TopNotification/TopAlert";
import "./CompanyLogo.css";
import Uploadbanner from "../../Conversations/components/ChatCard/components/Uploadbanner/Uploadbanner";

export default function CompanyLogo() {
  const BackendApiBaseUrl = process.env.REACT_APP_API_URL;

  const dispatch = useDispatch();
  const location = useLocation();

  const [imageUrl, setimageUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [fileList1, setFileList1] = useState();
  const [RequestKey, setRequestKey] = useState("");
  const [FileSize, setFileSize] = useState();
  const [uploadKey, setUploadKey] = useState(null);
  const [uploadURL, setUploadURL] = useState(null);
  const [fileAttachment, setFileAttachment] = useState("");
  const [uploadedImage, setUploadedImage] = useState("");
  const [fileSizeCheck, setFileSizeCheck] = useState(false);
  const [fileTypeCheck, setFileTypeCheck] = useState(false);
  const [CorruptedFileCheck, setCorruptedFileCheck] = useState();

  const success = useSelector(
    (state) => state.getCompanyDetailsReducer.success
  );

  const resp = useSelector(
    (state) => state.getCompanyProfileDetailsReducer.resp
  );

  useEffect(() => {
    dispatch(getCompanyProfileDetails());
  }, []);

  useEffect(() => {
    getPicture(location.state.Key);
  }, []);

  const onChange = ({ fileList: newFileList }) => {
    setFileList1(newFileList);
    setFileAttachment(newFileList);
  };

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        dispatch(resetCompanyProfileDetails());
        history.push("/companyprofile");
      }, 3000);
    }
  }, [success]);

  const handleBeforeUpload = (file) => {
    setLoading(true);
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        let image = document.createElement("img");
        image.src = event.target.result;

        image.onload = () => {
          if (
            file.type != "image/png" &&
            file.type != "image/jpeg" &&
            file.type != "image/jpg"
          ) {
            setFileTypeCheck(true);
            setLoading(false);
          } else if (file.size > 10000000) {
            setFileSizeCheck(true);
            setLoading(false);
          } else {
            resolve(file);
            setCorruptedFileCheck(false);
            onChange(file);
          }
        };

        image.onerror = () => {
          reject(new Error("Invalid image file"));
          setFileList1(null);
          setFileTypeCheck(true);
          setLoading(false);
          setCorruptedFileCheck(true);
        };
      };

      reader.readAsDataURL(file);
    });
  };

  const uploadImage = async (file) => {
    setLoading(true);
    const headers = await fetchToken();
    setUploadedImage(file);
    const payload = {
      type: "profilePic",
      contentType: file.type,
    };
    try {
      const imageUrl = `${BackendApiBaseUrl}/upload`;
      const data = await axios.post(imageUrl, payload, { headers });
      setUploadKey(data.data.Key);
      setUploadURL(data.data.uploadURL);
    } catch (error) {
      setLoading(false);
    }
  };

  const getPicture = (Key) => {
    var url = Key;
    if (url !== null) {
      setimageUrl(
        `${process.env.REACT_APP_S3_URL}${
          url?.charAt(0) !== "/" ? "/" : ""
        }${url}`
      );
      setRequestKey(Key);
    }
  };

  useEffect(() => {
    if (uploadKey !== null && uploadURL != null) {
      if (fileAttachment?.length > 0) {
        if (
          uploadedImage?.size > fileAttachment[0]?.size ||
          fileAttachment[0]?.lastModified > uploadedImage?.lastModified
        ) {
          uploadCroppedImage();
        }
      }
    }
  }, [uploadKey, uploadURL, fileAttachment]);

  const uploadCroppedImage = async () => {
    try {
      const respones = await axios.put(
        uploadURL,
        fileAttachment[0]?.originFileObj
      );
      getPicture(uploadKey);
      setLoading(false);
      dispatch(updateCompanyProfileDetails({ PictureUrl: uploadKey }));
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="companylogo-upload_main_cont">
        {fileTypeCheck ? (
          <TopAlert
            display={"flex"}
            title={
              "Cannot open the this file. The file may be corrupt, or in an unsupported format."
            }
            type="warning"
          />
        ) : null}
        {fileSizeCheck ? (
          <TopAlert
            display={"flex"}
            title={"File size should not exceed 10MB"}
            type="warning"
          />
        ) : null}
        {success && (
          <TopAlert
            display={"flex"}
            title={"Company logo successfully saved"}
            type="success"
          />
        )}
        <Col xs={24} sm={24} md={24} lg={24}>
          <div className="companylogo-cont-resp">
            <div className="companylogo-cont">
              <div className="companylogo-circle-subdiv">
                <div className="companylogo-heading">Company logo</div>
                <div>
                  {imageUrl && (
                    <div className="companylogo-circle">
                      {resp.length !== 0 ? (
                        <h1
                          style={{
                            color: "white",
                            display: "none",
                            margin: "auto",
                            fontSize: "100px",
                          }}
                        >
                          {resp.companyProfile.CompanyName.split("")[0].toUpperCase()}
                        </h1>
                      ) : null}
                      <img
                        src={imageUrl}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "fill",
                        }}
                      />
                    </div>
                  )}
                </div>

                <ImgCrop rotate>
                  <Upload
                    action={uploadImage}
                    beforeUpload={handleBeforeUpload}
                    onChange={onChange}
                    maxCount={1}
                    accept="image/png, image/jpeg, image/jpg"
                    showUploadList={false}
                  >
                    {loading ? (
                      <div>
                        <div className="lds-spinner">
                        </div>
                      </div>
                    ) : imageUrl ? (
                      <img src={editicon} alt="editicon" className="companylogo_edit" />
                    ) : (
                      <Uploadbanner width="150" height="150" aspectRatio="1:1" />
                    )}
                  </Upload>
                </ImgCrop>
              </div>
            </div>
          </div>
        </Col>
      </div>
    </>
  );
}